// This works because App.tsx has the unauthenticated route outside of the Dash, which requires auth.
import React from "react";
import Footer from "components/Footer";
import PublicPageShell from "components/PublicPageShell";
import "./index.scss";
import { useKas } from "contexts/KasContext";
import { LandingHeader } from "components/landing";

interface OptionalCallbackProps {
  children: React.ReactNode;
  callbackUrl?: string;
  notebookNotFound?: boolean;
  isGiftCard?: boolean;
}

export const DashWrapper: React.FC<OptionalCallbackProps> = (props) => {
  const { isUserLoggedIn, user, isLoading: isAuthLoading } = useKas();

  if (!isAuthLoading && isUserLoggedIn && user) {
    return <PublicPageShell>{props.children}</PublicPageShell>;
  } else {
    return (
      <UnauthenticatedDash
        callbackUrl={props.callbackUrl}
        notebookNotFound={props.notebookNotFound}
        isGiftCard={props.isGiftCard}
      >
        {props.children}
      </UnauthenticatedDash>
    );
  }
};

const UnauthenticatedDash: React.FC<OptionalCallbackProps> = (props) => {
  const redirectUrl =
    props.callbackUrl ?? `${window.location.pathname}${window.location.search}`;

  return (
    <div className="min-h-screen flex flex-col">
      <LandingHeader redirectUrl={redirectUrl} />

      <main className="flex-1">
        <div className="">{props.children}</div>
      </main>
      <Footer />
    </div>
  );
};

export default UnauthenticatedDash;
